import { mdiAlertOutline } from '@mdi/js'

export default {
  title: 'Violation',
  to: 'violation-headmaster',
  icon: mdiAlertOutline,
  resource: 'ViolationHeadMaster',
  action: 'read',
}
